import { createContext, useContext, useEffect, useState } from "react";
import i18n from "@/lib/i18n";
import api from "@/lib/api";

const AuthCtx = createContext(null);

function _applyUserLanguage(user) {
  const lang = user?.language;
  if (lang && (lang === "zh" || lang === "en") && i18n.language !== lang) {
    i18n.changeLanguage(lang);
    try { localStorage.setItem("lang", lang); } catch { /* ignore */ }
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      _applyUserLanguage(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    _applyUserLanguage(data);
    return data;
  };
  const register = async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name });
    setUser(data);
    return data;
  };
  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch {
      /* ignore */
    }
    setUser(null);
  };

  const updateLanguage = async (language) => {
    try {
      const { data } = await api.patch("/auth/me", { language });
      setUser(data);
      _applyUserLanguage(data);
      return data;
    } catch {
      /* ignore */
    }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, reload: load, updateLanguage }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used inside AuthProvider");
  return ctx;
}
